export default __webpack_public_path__ + "images/nvent-raychem-sidebyside-logo.png?472f8749e43fb2445543c0b53789b021";